import { Document, Font, Image, PDFDownloadLink, PDFViewer, Page, Text, View } from "@react-pdf/renderer";
import { numberToThaiCurrency, parseBankAccountCustomerBill } from "../../../utils/utils";
import Decimal from "decimal.js";
import { Modal } from "antd";
import React from "react";
import fontThai from "../../../assets/THSarabunNewRegular.ttf";
import fontChinese from "../../../assets/ZhuoJianGanLanJianTiRegular.ttf";
import { createInvoiceStyles } from "../../../styles/pdf/invoice";
import { changeFormatDateTime } from "../../../utils/date";
import { resolveImageUrl } from "../../../utils/imageUrl";
import { formatDigits, formatNumber } from "../../../utils/number";
import { renderMultilingualText } from "../../../utils/renderMultilingualText";
// Create invoiceStyles
// Registering the Noto Sans Thai font
Font.register({
  family: "THSarabunNew",
  src: fontThai,
});

Font.register({
  family: "ChineseFont",
  src: fontChinese,
});

export const CompanyBillerInvoice = ({ setIsOpenModal, isOpenModal, data }) => {
  const handleCancel = (e) => {
    setIsOpenModal(false);
  };
  return (
    <>
      <Modal open={isOpenModal} width={1024} onCancel={handleCancel} onOk={() => setIsOpenModal(false)}>
        <PDFViewer width="100%" height="600">
          <MyDocumentInvoice data={data} />
        </PDFViewer>
      </Modal>
      <PDFDownloadLink document={<MyDocumentInvoice data={data} />} fileName="example.pdf"></PDFDownloadLink>
    </>
  );
};

const MyDocumentInvoice = ({ data }) => {
  const columnConfig = {
    NO: 8,
    DESC: 42,
    COUNT: 10,
    PRICE: 20,
    AMOUNT: 20,
  };

  const invoiceStyles = createInvoiceStyles(columnConfig);

  // Group by company: same company → one bill, sum totals
  const groupedData = Object.values(
    data.reduce((acc, row) => {
      const key = `${row?.app_company?.id}`;
      if (!acc[key]) {
        acc[key] = { ...row, sum_total_bill: 0 };
      }
      acc[key].sum_total_bill += Number(row?.sum_total_bill || 0);
      return acc;
    }, {})
  );

  return (
    <Document>
      {groupedData.map((row, index) => {
        // 1) base numbers
        // TODO: Remove
        // const total = Number(row?.sum_total_bill || 0);
        // const vatRate = 0.07;
        // const whtRate = 0.03;

        // const vat = total * vatRate;
        // const totalWithVat = total + vat;

        // const wht = total * whtRate;
        // const net = totalWithVat - wht;

        const total = new Decimal(row?.sum_total_bill || 0);

        const vat = total.mul(0.07).toDecimalPlaces(2, Decimal.ROUND_HALF_UP);
        const totalWithVat = total.plus(vat).toDecimalPlaces(2, Decimal.ROUND_HALF_UP);

        const wht = total.mul(0.03).toDecimalPlaces(2, Decimal.ROUND_HALF_UP);
        const net = totalWithVat.minus(wht).toDecimalPlaces(2, Decimal.ROUND_HALF_UP);

        // 2) formatted (2 decimals + ปัดเศษตาม formatDigits)
        // TODO: Remove
        // const totalFmt = formatDigits(total);
        // const vatFmt = formatDigits(vat);
        // const totalWithVatFmt = formatDigits(totalWithVat);
        // const whtFmt = formatDigits(wht);
        // const netFmt = formatDigits(net);
        const totalFmt = formatNumber(total, 2);
        const vatFmt = formatNumber(vat, 2);
        const totalWithVatFmt = formatNumber(totalWithVat, 2);
        const whtFmt = formatNumber(wht, 2);
        const netFmt = formatNumber(net, 2);

        // 3) text
        const netThaiText = numberToThaiCurrency(netFmt);

        // 4) bank parse
        const { bankName, accountName, accountNo } = parseBankAccountCustomerBill(
          row?.app_company?.bank_account_company_bill,
          row?.app_company?.company_code
        );
        return (
          <Page key={row.id || index} size="A4" style={[invoiceStyles.page, { backgroundColor: "#FFFFFF" }]}>
            {/* title */}
            {/* invoice */}
            <View style={invoiceStyles.infoBoxWhite}>
              <View style={invoiceStyles.infoBoxHeader}>
                <Text style={invoiceStyles.infoBoxTitle}>{`ใบแจ้งหนี้/วางบิล`}</Text>
              </View>
              <View
                style={[
                  invoiceStyles.container,
                  {
                    flexDirection: "row",
                    alignItems: "flex-start",
                    justifyContent: "space-between",
                  },
                ]}
              >
                <View
                  style={[
                    invoiceStyles.section,
                    {
                      width: "25%", // 👈 fix space โลโก้
                      alignItems: "center",
                      justifyContent: "center",
                    },
                  ]}
                >
                  {row.app_company.company_bill_type === "ST"
                    ? (() => {
                        const defaultImage = row?.app_company?.app_companyimage?.[0]?.image;
                        const stImage = row?.app_company_type_st?.app_companyimage?.find((img) =>
                          img?.image?.includes("ST_CustomerBill")
                        );
                        const imagePath = stImage?.image || defaultImage;

                        if (imagePath) {
                          return (
                            <Image
                              style={[
                                invoiceStyles.image,
                                {
                                  width: "auto",
                                  height: "auto",
                                  objectFit: "contain",
                                },
                              ]}
                              src={resolveImageUrl(imagePath)}
                            />
                          );
                        }
                        return null;
                      })()
                    : row.app_company.app_companyimage?.[0] && (
                        <Image
                          style={[
                            invoiceStyles.image,
                            {
                              width: "auto",
                              height: "auto",
                              objectFit: "contain",
                            },
                          ]}
                          src={resolveImageUrl(row.app_company.app_companyimage[0].image)}
                        />
                      )}
                </View>
                <View
                  style={[
                    invoiceStyles.section,
                    {
                      width: "75%",
                    },
                  ]}
                >
                  <Text style={invoiceStyles.text}>
                    {row.app_company_type_st !== null
                      ? row.app_company_type_st.company_name
                      : row.app_company.company_name || "-"}
                  </Text>
                  {/* <Text style={invoiceStyles.text}>
                    {row.app_company_type_st !== null
                      ? row.app_company_type_st.company_address
                      : row.app_company.company_address || "-"}
                  </Text> */}
                  {row.app_company_type_st !== null
                    ? renderMultilingualText(row.app_company_type_st?.company_address, invoiceStyles)
                    : renderMultilingualText(row.app_company?.company_address, invoiceStyles)}
                  <Text style={invoiceStyles.text}>
                    {`โทร: `}
                    {row.app_company_type_st !== null
                      ? row.app_company_type_st.telephone
                      : row.app_company.telephone || "-"}
                  </Text>
                  <Text style={invoiceStyles.text}>
                    {`เลขประจำตัวผู้เสียภาษี: `}
                    {row.app_company_type_st !== null ? row.app_company_type_st.tax_id : row.app_company.tax_id || "-"}
                  </Text>
                </View>
              </View>
              {/* shipping detail */}
              <View style={invoiceStyles.padding}>
                <View style={invoiceStyles.container}>
                  <View style={invoiceStyles.column}>
                    <Text style={invoiceStyles.text}></Text>
                    <Text
                      style={invoiceStyles.textMd}
                    >{`ลูกค้า/Company Name: ${row.app_company?.company_name || "-"}`}</Text>
                    {/* <Text
                      style={invoiceStyles.textMd}
                    >{`ที่อยู่/Address: ${row.app_company?.company_address || "-"}`}</Text> */}
                    <Text style={invoiceStyles.textMd}>
                      <Text style={invoiceStyles.fontThai}>{`ที่อยู่/Address:`}</Text>

                      {renderMultilingualText(` ${row.app_company?.company_address || "-"}`, invoiceStyles)}
                    </Text>
                    <Text
                      style={invoiceStyles.textMd}
                    >{`เลขประจำตัวผู้เสียภาษี /Tax ID : ${row.app_company?.tax_id || "-"}`}</Text>
                  </View>
                  <View style={invoiceStyles.column}>
                    <Text style={invoiceStyles.text}></Text>
                    <Text style={invoiceStyles.text}></Text>
                    <Text style={invoiceStyles.textMd}>{`เลขที่ ${row?.invoice_no || "-"}`}</Text>
                    <Text style={invoiceStyles.textMd}>{`วันที่ ${changeFormatDateTime(row?.invoice_date)}`}</Text>
                  </View>
                </View>
              </View>
            </View>

            {/* table */}
            <View style={invoiceStyles.table}>
              <View
                style={[
                  invoiceStyles.tableRow,
                  invoiceStyles.textBold,
                  invoiceStyles.textMs,
                  invoiceStyles.tableBorder,
                ]}
              >
                <View style={[invoiceStyles.tableColNO]}>
                  <Text style={[invoiceStyles.tableCell, invoiceStyles.tableCellCenter]}>{`ลำดับที่`}</Text>
                </View>
                <View style={[invoiceStyles.tableColDESC]}>
                  <Text style={[invoiceStyles.tableCell, invoiceStyles.tableCellCenter]}>{`รายการ`}</Text>
                </View>
                <View style={[invoiceStyles.tableColCOUNT]}>
                  <Text style={[invoiceStyles.tableCell, invoiceStyles.tableCellRight]}>{`จำนวน`}</Text>
                </View>
                <View style={[invoiceStyles.tableColPRICE]}>
                  <Text style={[invoiceStyles.tableCell, invoiceStyles.tableCellRight]}>{`ราคาต่อหน่วย`}</Text>
                </View>
                <View style={[invoiceStyles.tableColAMOUNT]}>
                  <Text style={[invoiceStyles.tableCell, invoiceStyles.tableCellRight]}>{`จำนวนเงิน`}</Text>
                </View>
              </View>

              {/* Rows */}
              <View style={[invoiceStyles.tableRow, invoiceStyles.textMs, invoiceStyles.tableRowItem]}>
                <View style={[invoiceStyles.tableColNO]}>
                  <Text style={[invoiceStyles.tableCell, invoiceStyles.tableCellRight]}>{`1`}</Text>
                </View>
                <View style={[invoiceStyles.tableColDESC]}>
                  <Text style={[invoiceStyles.tableCell, invoiceStyles.textMd]}>
                    {renderMultilingualText(`ค่าบริการ`)}
                  </Text>
                </View>
                <View style={[invoiceStyles.tableColCOUNT]}>
                  <Text style={[invoiceStyles.tableCell, invoiceStyles.tableCellRight]}>{`1`}</Text>
                </View>
                <View style={[invoiceStyles.tableColPRICE]}>
                  <Text style={[invoiceStyles.tableCell, invoiceStyles.tableCellRight]}>
                    {/* {Number(row?.sum_total_bill || 0).toLocaleString(undefined, { minimumFractionDigits: 2 })} */}
                    {totalFmt}
                  </Text>
                </View>
                <View style={[invoiceStyles.tableColAMOUNT]}>
                  <Text style={[invoiceStyles.tableCell, invoiceStyles.tableCellRight]}>
                    {/* {Number(row?.sum_total_bill || 0).toLocaleString(undefined, { minimumFractionDigits: 2 })} */}
                    {totalFmt}
                  </Text>
                </View>
              </View>
            </View>

            {/* Payment method */}
            <View style={[invoiceStyles.padding]}>
              <View style={invoiceStyles.container}>
                <View style={invoiceStyles.column}>
                  <Text style={invoiceStyles.textMd}></Text>
                  <Text style={invoiceStyles.textMd}></Text>
                  <Text style={invoiceStyles.textMd}></Text>
                </View>
                <View style={invoiceStyles.column}>
                  {/* SHIPPING COST */}
                  <View style={invoiceStyles.costRow}>
                    <Text style={[invoiceStyles.textMd, invoiceStyles.costLabel]}></Text>
                    <Text style={[invoiceStyles.textMd, invoiceStyles.costValue]}></Text>
                  </View>

                  {/* รายการย่อย */}
                  <View style={invoiceStyles.costRow}>
                    <Text style={[invoiceStyles.textMd, invoiceStyles.costLabelIndent]}></Text>
                    <Text style={[invoiceStyles.textMd, invoiceStyles.costValue]}></Text>
                  </View>
                  <View style={invoiceStyles.costRow}>
                    <Text style={[invoiceStyles.textMd, invoiceStyles.costLabelIndent]}></Text>
                    <Text style={[invoiceStyles.textMd, invoiceStyles.costValue]}></Text>
                  </View>
                  <View style={invoiceStyles.costRow}>
                    <Text style={[invoiceStyles.textMd, invoiceStyles.costLabelIndent]}></Text>
                    <Text style={[invoiceStyles.textMd, invoiceStyles.costValue]}></Text>
                  </View>
                  <View style={invoiceStyles.costRow}>
                    <Text style={[invoiceStyles.textMd, invoiceStyles.costLabelIndent]}></Text>
                    <Text style={[invoiceStyles.textMd, invoiceStyles.costValue]}></Text>
                  </View>
                </View>
              </View>
            </View>

            {/* Note */}
            <View style={[invoiceStyles.marginLeft]}>
              <View style={invoiceStyles.container}>
                <View style={[invoiceStyles.mergedColumn3]}>
                  <Text style={[invoiceStyles.textMd, invoiceStyles.textLeft]}>{`หมายเหตุ`}</Text>
                </View>
                <View style={invoiceStyles.singleColumn}>
                  <Text style={[invoiceStyles.textMd, invoiceStyles.textLeft]}>{`รวมเป็นเงิน`}</Text>
                </View>
                <View style={invoiceStyles.singleColumn}>
                  <Text style={[invoiceStyles.textMd, invoiceStyles.textRight]}>{totalFmt}</Text>
                </View>
              </View>
            </View>

            {/* Payment method */}
            <View style={[invoiceStyles.marginLeft]}>
              <View style={invoiceStyles.container}>
                <View style={[invoiceStyles.mergedColumn3]}>
                  <Text style={[invoiceStyles.textMd, invoiceStyles.textLeft]}>{`การชำระเงิน กรุณาโอนเข้าบัญชี`}</Text>
                </View>
                <View style={invoiceStyles.singleColumn}>
                  <Text style={[invoiceStyles.textMd, invoiceStyles.textLeft]}>{`ภาษีมูลค่าเพิ่ม 7%`}</Text>
                </View>
                <View style={invoiceStyles.singleColumn}>
                  <Text style={[invoiceStyles.textMd, invoiceStyles.textRight]}>{vatFmt || "-"}</Text>
                </View>
              </View>
            </View>

            {/* Bank account */}
            <View style={[invoiceStyles.marginLeft]}>
              <View style={invoiceStyles.container}>
                <View style={[invoiceStyles.mergedColumn3]}>
                  <Text
                    style={[invoiceStyles.textMd, invoiceStyles.textLeft]}
                  >{`ธนาคาร ${bankName || "-"} เลขที่ ${accountNo || "-"}`}</Text>
                </View>
                <View style={invoiceStyles.singleColumn}>
                  <Text style={[invoiceStyles.textMd, invoiceStyles.textLeft]}>{`ราคารวมภาษีมูลค่าเพิ่ม`}</Text>
                </View>
                <View style={invoiceStyles.singleColumn}>
                  <Text style={[invoiceStyles.textMd, invoiceStyles.textRight]}>{totalWithVatFmt || "0.00"}</Text>
                </View>
              </View>
            </View>

            {/* Bank account name */}
            <View style={[invoiceStyles.marginLeft]}>
              <View style={invoiceStyles.container}>
                <View style={[invoiceStyles.mergedColumn3]}>
                  <Text
                    style={[invoiceStyles.textMd, invoiceStyles.textLeft]}
                  >{`ชื่อบัญชี ${accountName || "-"} `}</Text>
                </View>
                <View style={invoiceStyles.singleColumn}>
                  <Text style={[invoiceStyles.textMd, invoiceStyles.textLeft]}>{`ภาษีหัก ณ ที่จ่าย 3%`}</Text>
                </View>
                <View style={invoiceStyles.singleColumn}>
                  <Text style={[invoiceStyles.textMd, invoiceStyles.textRight]}>{whtFmt || "0.00"}</Text>
                </View>
              </View>
            </View>

            {/* Total */}
            <View style={[invoiceStyles.marginLeft]}>
              <View style={invoiceStyles.container}>
                <View style={[invoiceStyles.mergedColumn3]}>
                  <Text style={[invoiceStyles.textMd, invoiceStyles.textLeft]}>{netThaiText || "-"}</Text>
                </View>
                <View style={invoiceStyles.singleColumn}>
                  <Text style={[invoiceStyles.textMd, invoiceStyles.textLeft]}>{`รวมเป็นเงินสุทธิ`}</Text>
                </View>
                <View style={invoiceStyles.singleColumn}>
                  <Text style={[invoiceStyles.textMd, invoiceStyles.textRight]}>{netFmt || "0.00"}</Text>
                </View>
              </View>
            </View>
          </Page>
        );
      })}
    </Document>
  );
};
